// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2ltfR","inner":"Footer_inner__YnFmr"};